<template>
	<div class="action-flow-node" style="height: 240px;">
		<div class="action-flow-title">Conditional</div>
		<div class="action-flow-hint">Branch to different actions based on conditions of an input.</div>
		
		<ActionParamHint label="Condition" hint="What condition to check for." param-class="param-config"
			param-input-type="text"  param-input-label="Condition" @param-change="handleParamChange"
			:param-input-value="parameters.condition"
		/>
		<ActionParamHint label="Data" hint="Data to consider for the condition. You can feed in more than one object to this input." param-class="param-tgt" />
		<ActionParamHint label="Result True" hint="Branch if the result is true" param-class="param-src" />
		<ActionParamHint label="Result False" hint="Branch if the result is false" param-class="param-src" />
		
		<Handle type="target" id="tgt-data" :position="Position.Left" style="top: 135px;" />
		<Handle type="source" id="src-branch1" :position="Position.Right" style="top: 175px;" />
		<Handle type="source" id="src-branch2" :position="Position.Right" style="top: 215px;" />
	</div>
</template>

<script setup>
/* eslint-disable */
import { ref, watch } from 'vue'
import { Handle, Position, useNodesData, useVueFlow } from '@vue-flow/core'
import ActionParamHint from './action-param-hint.vue'

const props = defineProps({
	id: String,
});

// Access the current node's data
const nodeData = useNodesData(() => props.id);
const { updateNode } = useVueFlow()

// Store parameter values
const parameters = ref({
	condition: '',
});

// Watch for changes in nodeData and update parameters accordingly
watch(nodeData, (newNodeData) => {
	if (newNodeData) {
		parameters.value = {
			condition: newNodeData.data?.condition || '',
		};
	}
}, { immediate: true });

// Handle parameter changes from ActionParamHint components
const handleParamChange = (paramData) => {
	// Store the parameter value based on the label
	let key = paramData.label.toLowerCase();
	if (!(key in parameters.value)) {
		console.error(`Unknown parameter label: ${paramData.label}`);
		return;
	}
	parameters.value[key] = paramData.value;
	
	// Update the node data in Vue Flow.
	updateNode(props.id, (node) => ({
		data: {
			...node.data,
			...parameters.value
		}
	}));
}

</script>
	